module.exports = __webpack_public_path__ + "static/media/constellations.108ceead.PNG";